import React from "react";

import { Div } from "Common/HTML";
import { Body1, Body2 } from "Theme/BodyText";
import { Card } from "Theme/Card";

import makeBem from "Utils/makeBem";

const bem = makeBem("ApplicationStepCard");

const ONBOARDING_EMAIL = "onboarding@simplyinsured.com";

const reasonCopy = {
  non_responsive:
    "Upon multiple attempts to reach you, we were unable to receive any replies from you. This may indicate that your contact information may be outdated. Please provide your most updated contact information to onboarding@simplyinsured.com for our team to reach you. Thank you!",
  audit_required:
    "As part of routine procedures, your health insurance carrier is requiring an audit of certain documents from your company. To ensure seamless coverage for your current and upcoming plan(s), please provide your most updated contact information immediately at onboarding@simplyinsured.com. Thank you!",
  incomplete_renewal:
    "Your upcoming policy renewal is due soon but still incomplete. We want to ensure a seamless renewal for your company. Please provide your most updated contact information immediately at onboarding@simplyinsured.com for our team to reach you. Thank you!",
};

type Props = {
  contactRequiredReason?: "non_responsive" | "audit_required" | "incomplete_renewal" | string;
  supportRep?: { phone?: string | null } | null; // legacy object; we only care about phone now
};

export class ContactRequiredCardDumb extends React.Component<Props> {
  render() {
    const { contactRequiredReason, supportRep } = this.props;

    const copy =
      (contactRequiredReason && (reasonCopy as any)[contactRequiredReason]) ||
      // fallback (in case reason missing/malformed)
      `Please provide your most updated contact information at ${ONBOARDING_EMAIL} for our team to reach you. Thank you!`;

    const phone = supportRep?.phone;

    return (
      <Card mt={4} p={5}>
        <Body1 weight="bold" mb={4}>
          Please Contact our Team
        </Body1>

        <Body2 className={bem(null, "gray800")} mb={4}>
          {copy}
        </Body2>

        <Body2 className={bem(null, "gray800")} mb={4}>
          {phone && (
            <Div>
              <strong>Phone</strong>: {phone}
            </Div>
          )}

          <Div style={{ paddingLeft: phone ? "64px" : undefined }}>
            <strong>E-mail</strong>: <a href={`mailto:${ONBOARDING_EMAIL}`}>{ONBOARDING_EMAIL}</a>
          </Div>
        </Body2>
      </Card>
    );
  }
}

export default ContactRequiredCardDumb;
